import { AuthenticationService } from '../auth/services/authentication.service';

export function initCookieLogin(authenticationService: AuthenticationService) {
  return () => authenticationService.loginWithCookie().toPromise();
}
